import PropTypes from "prop-types";

import { cn } from "@helpers/general";

import LuxeCheck from "@svgs/luxe_check.svg";
import LuxeSelected from "@svgs/luxe_selected.svg";
import LuxeUnselected from "@svgs/luxe_unselected.svg";

function LuxeMemberCell({ perk, isLuxe, sideCartInfo, formatCurrency, maxTieredDiscountLuxe }) {
  if (typeof perk.al_luxe_member === "boolean") {
    return <LuxeCheck stroke="#000000" width="15px" height="10px" />;
  }
  if (perk.al_luxe_member === "Member") {
    return (
      <>
        {isLuxe ? (
          <LuxeSelected className="mr-[5px]" width="17px" height="17px" />
        ) : (
          <LuxeUnselected className="mr-[5px]" width="17px" height="17px" />
        )}
        <span className="typo-micro">{perk.al_luxe_member}</span>
      </>
    );
  }

  if (perk.type === "footer") {
    return (
      <div
        className={cn(
          "typo-micro font-bold rounded bg-white py-[3px] px-[15px]",
          isLuxe ? "text-secondary" : "text-black"
        )}
      >
        {formatCurrency(sideCartInfo.finalAmountLux)}
      </div>
    );
  }

  return perk.al_luxe_member.replace("{0}", maxTieredDiscountLuxe);
}

LuxeMemberCell.propTypes = {
  perk: PropTypes.shape({
    al_luxe_member: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    type: PropTypes.string,
  }).isRequired,
  isLuxe: PropTypes.bool.isRequired,
  sideCartInfo: PropTypes.shape({
    finalAmountLux: PropTypes.number.isRequired,
  }).isRequired,
  formatCurrency: PropTypes.func.isRequired,
  maxTieredDiscountLuxe: PropTypes.number.isRequired,
};

export default LuxeMemberCell;
